import { useState, useEffect } from "react";
import { io, Socket } from "socket.io-client";
import api, { socketBaseUrl } from "../utils/axios/api";

interface UseChatParams {
  productOrOrderId: string | undefined;
  chatType: "PRODUCT" | "ORDER";
  clientId: string | null;
}

interface UserData {
  id: string;
  name: string;
  role: "Client" | "Entrepreneur";
}

interface Store {
  id: string;
  name: string;
  entrepeneurId: string;
}

export function useChat({
  chatType,
  clientId,
}: UseChatParams) {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [showChat, setShowChat] = useState(false);
  const [entrepreneurUser, setEntrepreneurUser] = useState<UserData | null>(
    null
  );
  const [store = null, setStore] = useState<Store | null>(null);

  useEffect(() => {
    const newSocket = io(socketBaseUrl);
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  async function openChat(id?: string) {
    if (!clientId || !id) return;
    try {
      const response = await api.get(
        `/chat/entrepreneur?id=${id}&type=${chatType}`
      );
      if (response.data) {
        setEntrepreneurUser(response.data.user);
        setStore(response.data.store);

        socket?.emit("login", clientId);
        setShowChat(true);
      }
    } catch (err) {
      console.error("Erro ao buscar empreendedor:", err);
    }
  }

  function closeChat() {
    setShowChat(false);
    setEntrepreneurUser(null);
  }

  return { socket, showChat, entrepreneurUser, store, openChat, closeChat };
}
